import React, { useRef, useState, useEffect } from "react";
import {
  VictoryChart,
  VictoryBar,
  VictoryAxis,
  VictoryContainer,
  VictoryLabel
} from "victory";
import icon1 from "../../../../assets/images/DashboardIcons/c0b38c06-c60e-4483-af0a-06fcce3cedae.png";
import icon2 from "../../../../assets/images/DashboardIcons/cdd3e435-d727-4cb6-9a5d-113fcf79a2cd.png";
import icon3 from "../../../../assets/images/DashboardIcons/7ba17202-ef0a-4aca-99d9-2111af125d69.png";
import icon4 from "../../../../assets/images/DashboardIcons/abc244d6-1fe7-4707-9534-249d2af001be.png";
import icon5 from "../../../../assets/images/DashboardIcons/8e7c2d88-0c97-4dba-b5a2-33af1c2c34c1.png";
import icon6 from "../../../../assets/images/DashboardIcons/6a4e080a-87e6-4a13-a856-387202151100.png";
import icon7 from "../../../../assets/images/DashboardIcons/f9ae47be-46b7-4a1b-a5cf-60e4e55e7f83.png";
import icon8 from "../../../../assets/images/DashboardIcons/b6d8ed48-219e-4df4-9c33-69822c65be6b.png";
import icon9 from "../../../../assets/images/DashboardIcons/6f9ba7c8-4883-4478-a7cd-7f670e77ae04.png";
import icon10 from "../../../../assets/images/DashboardIcons/0c5d9fc5-01e2-4e4a-a904-83fd776bdc12.png";
import icon11 from "../../../../assets/images/DashboardIcons/3842eefa-172a-4677-a7fb-8bff61863437.png";
import icon12 from "../../../../assets/images/DashboardIcons/57beb050-5157-4d49-9be4-99bff98a141f.png";
import icon13 from "../../../../assets/images/DashboardIcons/e3e54db7-5199-4f02-9801-a6c44cb6a093.png";
import icon14 from "../../../../assets/images/DashboardIcons/91be33c5-774a-41d7-8bfc-bf24fcd76852.png";
import icon15 from "../../../../assets/images/DashboardIcons/bff671a4-7d9a-46f9-b467-c9220e8296d4.png";
import icon16 from "../../../../assets/images/DashboardIcons/94f69bc0-0424-45df-b066-d500cf9d72c9.png";
import icon17 from "../../../../assets/images/DashboardIcons/e490153a-983e-4986-83dd-d57dafbfd628.png";
import icon18 from "../../../../assets/images/DashboardIcons/f3304f30-b821-480d-ac11-d7a46de02de7.png";
import icon19 from "../../../../assets/images/DashboardIcons/4c407ec6-ffde-4c07-987c-db3e75017a37.png";
import icon20 from "../../../../assets/images/DashboardIcons/ac67cae5-35cc-4a6b-b5e3-ef97ec5f76ee.png";
import icon21 from "../../../../assets/images/DashboardIcons/eb2d5b1f-d4a9-4e3a-8e76-f015778f0426.png";
import icon22 from "../../../../assets/images/DashboardIcons/3ab9e7b7-f21d-4a7a-b93f-f684d16e3ce6.png";


const dashboardIcons: Record<string, any> = {
  "c0b38c06-c60e-4483-af0a-06fcce3cedae": icon1,
  "cdd3e435-d727-4cb6-9a5d-113fcf79a2cd": icon2,
  "7ba17202-ef0a-4aca-99d9-2111af125d69": icon3,
  "abc244d6-1fe7-4707-9534-249d2af001be": icon4,
  "8e7c2d88-0c97-4dba-b5a2-33af1c2c34c1": icon5,
  "6a4e080a-87e6-4a13-a856-387202151100": icon6,
  "f9ae47be-46b7-4a1b-a5cf-60e4e55e7f83": icon7,
  "b6d8ed48-219e-4df4-9c33-69822c65be6b": icon8,
  "6f9ba7c8-4883-4478-a7cd-7f670e77ae04": icon9,
  "0c5d9fc5-01e2-4e4a-a904-83fd776bdc12": icon10,
  "3842eefa-172a-4677-a7fb-8bff61863437": icon11,
  "57beb050-5157-4d49-9be4-99bff98a141f": icon12,
  "e3e54db7-5199-4f02-9801-a6c44cb6a093": icon13,
  "91be33c5-774a-41d7-8bfc-bf24fcd76852": icon14,
  "bff671a4-7d9a-46f9-b467-c9220e8296d4": icon15,
  "94f69bc0-0424-45df-b066-d500cf9d72c9": icon16,
  "e490153a-983e-4986-83dd-d57dafbfd628": icon17,
  "f3304f30-b821-480d-ac11-d7a46de02de7": icon18,
  "4c407ec6-ffde-4c07-987c-db3e75017a37": icon19,
  "ac67cae5-35cc-4a6b-b5e3-ef97ec5f76ee": icon20,
  "eb2d5b1f-d4a9-4e3a-8e76-f015778f0426": icon21,
  "3ab9e7b7-f21d-4a7a-b93f-f684d16e3ce6": icon22,
};

type WorkOrderPerAssetProps = {
  data: {
    assetTypeId: string;
    assetTypeName: string;
    openWorkOrderCount: number;
    buildingName: string;
  }[];
};

const WorkOrderPerAssetChart: React.FC<WorkOrderPerAssetProps> = ({
  data,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        setDimensions({ width, height });
      }
    });

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);



  const aggregatedData = Object.values(
    data.reduce((acc: Record<string, any>, item) => {
      if (!acc[item.assetTypeId]) {
        acc[item.assetTypeId] = {
          assetId: item.assetTypeId,
          assetTypeName: item.assetTypeName,
          totalOpenWorkOrderCount: 0,
        };
      }
      acc[item.assetTypeId].totalOpenWorkOrderCount += item.openWorkOrderCount;
      return acc;
    }, {})
  );

  const breakdownMap: Record<string, typeof data> = {};
  data.forEach((item) => {
    if (!breakdownMap[item.assetTypeId]) breakdownMap[item.assetTypeId] = [];
    breakdownMap[item.assetTypeId].push(item);
  });

  const totals = aggregatedData.map((d) => d.totalOpenWorkOrderCount);
  const min = Math.min(...totals);
  const max = Math.max(...totals);

  const getColor = (value: number) => {
    const ratio = (value - min) / (max - min || 1);
    const startColor = [173, 216, 230];
    const endColor = [0, 0, 139];
    const r = Math.round(startColor[0] + (endColor[0] - startColor[0]) * ratio);
    const g = Math.round(startColor[1] + (endColor[1] - startColor[1]) * ratio);
    const b = Math.round(startColor[2] + (endColor[2] - startColor[2]) * ratio);
    return `rgb(${r}, ${g}, ${b})`;
  };

  const [tooltipInfo, setTooltipInfo] = useState<{
    datum: any;
    x: number;
    y: number;
  } | null>(null);

  const IconTickLabel = ({ x, y, text, index }: any) => {
  const assetId = aggregatedData.find((d) => d.assetTypeName === text)?.assetId;
  const imgSrc = dashboardIcons[assetId!] || dashboardIcons["c0b38c06-c60e-4483-af0a-06fcce3cedae"];

  // Calculate width dynamically based on number of bars and chart width
  const barWidth = dimensions.width / aggregatedData.length / 1.5; // adjust 1.5 for padding
  const size = Math.min(barWidth, 50); // optional max size

  return (
    <foreignObject x={x - size / 2} y={y + 5} width={size} height={size}>
      <img src={imgSrc} width={size} height={size} alt={text} />
    </foreignObject>
  );
};

  return (
    <div  ref={containerRef} style={{ width: "100%", height: "100%"   }}>
      {tooltipInfo && (
        <div
          style={{
            position: "absolute",
            top: tooltipInfo.y,
            left: tooltipInfo.x,
            transform: "translate(-50%, -100%)",
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: 6,
            padding: 10,
            maxHeight: 300,
            overflowY: "auto",
            fontSize: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            zIndex: 10,
            minWidth: 200,
          }}
        >
          <div style={{ fontWeight: "bold", marginBottom: 6 }}>
            {tooltipInfo.datum.assetTypeName} — Total:{" "}
            {breakdownMap[tooltipInfo.datum.assetId].reduce(
              (sum, i) => sum + i.openWorkOrderCount,
              0
            )}
          </div>
          {breakdownMap[tooltipInfo.datum.assetId].map((item) => (
            <div key={item.buildingName} style={{ marginBottom: 4 }}>
              • {item.buildingName}: {item.openWorkOrderCount}
            </div>
          ))}
        </div>
      )}

      <VictoryChart
        width={dimensions.width}
        height={dimensions.height}
        domainPadding={{ x: 100, y: 40 }}
        padding={{ top: 20, bottom: 80, left: 60, right: 20 }}
        containerComponent={<VictoryContainer responsive={false} />}
      >
        <VictoryAxis
          label=""
          tickValues={aggregatedData.map((d) => d.assetTypeName)}
          tickLabelComponent={<IconTickLabel />}
          axisLabelComponent={<VictoryLabel dy={40} />}
        />
        <VictoryAxis
          dependentAxis
          label=""
          style={{
            axis: { stroke: "transparent" },
          }}
        />
        <VictoryBar
          data={aggregatedData}
          x="assetTypeName"
          y="totalOpenWorkOrderCount"
          barRatio={1}
          cornerRadius={{ topLeft: 10, topRight: 10, bottomLeft: 10, bottomRight: 10 }}
          
          style={{ data: { fill: ({ datum }) => getColor(datum.totalOpenWorkOrderCount) } }}
          events={[
            {
              target: "data",
              eventHandlers: {
                onMouseEnter: (evt, props) => {
                  const rect = (evt.currentTarget as HTMLElement).getBoundingClientRect();
                  const containerRect = containerRef.current!.getBoundingClientRect();

                  const x = rect.left - containerRect.left + rect.width / 2;
                  const y = containerRect.top;

                  setTooltipInfo({ datum: props.datum, x, y });
                },
                onMouseLeave: () => setTooltipInfo(null),
              },
            },
          ]}
        />
      </VictoryChart>
    </div>
  );
};

export default WorkOrderPerAssetChart;
